import { collection, getDocs } from "firebase/firestore";

const fetchRestaurantPerformance = async (db, cutoffDate) => {
  try {
    // Fetch all restaurants from the `users` collection
    const usersRef = collection(db, "users");
    const usersSnapshot = await getDocs(usersRef);

    // Create a map of restaurant IDs to their names
    const restaurants = usersSnapshot.docs.map((doc) => ({
      id: doc.id,
      name: doc.data().restaurantName,
    }));

    // Fetch all invoices from the `invoices` collection
    const invoicesRef = collection(db, "invoices");
    const invoicesSnapshot = await getDocs(invoicesRef);

    // Helper to parse invoice date
    const parseDate = (createdAt) => {
      if (createdAt && createdAt.seconds) {
        return new Date(createdAt.seconds * 1000);
      } else if (typeof createdAt === 'string') {
        return new Date(createdAt);
      }
      return null;
    };

    // Aggregate orders and revenue for each restaurant
    const restaurantPerformance = restaurants.map((restaurant) => {
      const restaurantInvoices = invoicesSnapshot.docs.filter((invoiceDoc) => {
        if (invoiceDoc.data().userId !== restaurant.id) return false;
        if (cutoffDate) {
          const invoiceDate = parseDate(invoiceDoc.data().createdAt);
          if (!invoiceDate || invoiceDate < cutoffDate) return false;
        }
        return true;
      });

      const orders = restaurantInvoices.length;
      const revenue = restaurantInvoices.reduce((total, invoiceDoc) => {
        const items = invoiceDoc.data().items || [];
        const totalRevenueForInvoice = items.reduce(
          (sum, item) => sum + parseFloat(item.price) * item.quantity,
          0
        );
        return total + totalRevenueForInvoice;
      }, 0);

      return {
        name: restaurant.name,
        orders,
        revenue: parseFloat(revenue.toFixed(2)),
      };
    });

    return restaurantPerformance;
  } catch (error) {
    console.error("Error fetching restaurant performance data: ", error);
    throw error;
  }
};

export default fetchRestaurantPerformance;
